import _ from "lodash";
import { twMerge } from "tailwind-merge";
import { useMenu } from "../../../store/global/useMenu";
import { useLinkContext } from "./link-context";

export function LinkItemText({ className, ...rest }) {
  const ctx = useLinkContext()
  const isOpen = useMenu(st => st.data.open)
  const hasSubmenu = useMenu(st => st.data.itens[ctx.name].submenu)


  return (
    <span {...rest} className={twMerge(
      "transition-opacity duration-300 flex-1",
      !isOpen && "opacity-0 pointer-events-none hidden",
      hasSubmenu && "flex group-data-[open=true]:group-data-[menu-open=false]:opacity-100 ",

      // "group-hover:group-data-[menu-open=false]:opacity-100",
      className)} />
  );
}
